import contractSelection from './contract-selection'
import currentSituation from './current-situation'
import financialInvestmentAllocation from './financial-investment-allocation'
import financialInvestmentSummary from './financial-investment-summary'
import investmentConfiguration from './investment-configuration'
import nonCustomerQualification from './non-customer-qualification'
import pivotAccountFunding from './pivot-account-funding'
import synthesis from './synthesis'
import updateQualification from './update-qualification'

export default {
  currentSituation,
  updateQualification,
  nonCustomerQualification,
  investmentConfiguration,
  synthesis,
  contractSelection,
  financialInvestmentSummary,
  pivotAccountFunding,
  financialInvestmentAllocation
}
